module.exports = __webpack_public_path__ + "static/media/Resistance.e8f48cf2.jpg";